import "core-js/modules/es.array.sort.js";
import { uuid as e, getBrowserLocale as n, getTimeZone as t, paramsParse as r, dotProp as i } from "analytics-utils";
import { get as a, remove as o, set as u, globalContext as c, KEY as s } from "@analytics/global-storage-utils";
import { isObject as l, PREFIX as f, isFunction as d, isBoolean as p, isString as m, isBrowser as g, isArray as h } from "@analytics/type-utils";
function v() {
  return v = Object.assign || function (e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, v.apply(this, arguments);
}
var y = "function",
  b = "undefined",
  I = "@@redux/" + Math.random().toString(36),
  w = /* #__PURE__ */function () {
    return typeof Symbol === y && Symbol.observable || "@@observable";
  }(),
  E = " != " + y;
function P(e, n, t) {
  var r;
  if (typeof n === y && typeof t === b && (t = n, n = void 0), typeof t !== b) {
    if (typeof t !== y) throw new Error("enhancer" + E);
    return t(P)(e, n);
  }
  if (typeof e !== y) throw new Error("reducer" + E);
  var i = e,
    a = n,
    o = [],
    u = o,
    c = !1;
  function s() {
    u === o && (u = o.slice());
  }
  function f() {
    return a;
  }
  function d(e) {
    if (typeof e !== y) throw new Error("Listener" + E);
    var n = !0;
    return s(), u.push(e), function () {
      if (n) {
        n = !1, s();
        var t = u.indexOf(e);
        u.splice(t, 1);
      }
    };
  }
  function p(e) {
    if (!l(e)) throw new Error("Act != obj");
    if (typeof e.type === b) throw new Error("ActType " + b);
    if (c) throw new Error("Dispatch in reducer");
    try {
      c = !0, a = i(a, e);
    } finally {
      c = !1;
    }
    for (var n = o = u, t = 0; t < n.length; t++) (0, n[t])();
    return e;
  }
  return p({
    type: "@@redux/INIT"
  }), (r = {
    dispatch: p,
    subscribe: d,
    getState: f,
    replaceReducer: function replaceReducer(e) {
      if (typeof e !== y) throw new Error("next reducer" + E);
      i = e, p({
        type: "@@redux/INIT"
      });
    }
  })[w] = function () {
    var e,
      n = d;
    return (e = {
      subscribe: function subscribe(e) {
        if ("object" != typeof e) throw new TypeError("Observer != obj");
        function t() {
          e.next && e.next(f());
        }
        return t(), {
          unsubscribe: n(t)
        };
      }
    })[w] = function () {
      return this;
    }, e;
  }, r;
}
function S(e, n) {
  var t = n && n.type;
  return "action " + (t && t.toString() || "?") + "reducer " + e + " returns " + b;
}
function N() {
  var e = [].slice.call(arguments);
  return 0 === e.length ? function (e) {
    return e;
  } : 1 === e.length ? e[0] : e.reduce(function (e, n) {
    return function () {
      return e(n.apply(void 0, [].slice.call(arguments)));
    };
  });
}
function O() {
  var e = arguments;
  return function (n) {
    return function (t, r, i) {
      var a,
        o = n(t, r, i),
        u = o.dispatch,
        c = {
          getState: o.getState,
          dispatch: function dispatch(e) {
            return u(e);
          }
        };
      return a = [].slice.call(e).map(function (e) {
        return e(c);
      }), v({}, o, {
        dispatch: u = N.apply(void 0, a)(o.dispatch)
      });
    };
  };
}
var A = f + "anon_id",
  _ = f + "user_id",
  x = f + "user_traits",
  k = {
    __proto__: null,
    ANON_ID: A,
    USER_ID: _,
    USER_TRAITS: x
  },
  j = "userId",
  T = "anonymousId",
  z = ["bootstrap", "params", "campaign", "initializeStart", "initialize", "initializeEnd", "ready", "resetStart", "reset", "resetEnd", "pageStart", "page", "pageEnd", "pageAborted", "trackStart", "track", "trackEnd", "trackAborted", "identifyStart", "identify", "identifyEnd", "identifyAborted", "userIdChanged", "registerPlugins", "enablePlugin", "disablePlugin", "online", "offline", "setItemStart", "setItem", "setItemEnd", "setItemAborted", "removeItemStart", "removeItem", "removeItemEnd", "removeItemAborted"],
  M = ["name", "EVENTS", "config", "loaded"],
  q = z.reduce(function (e, n) {
    return e[n] = n, e;
  }, {
    registerPluginType: function registerPluginType(e) {
      return "registerPlugin:" + e;
    },
    pluginReadyType: function pluginReadyType(e) {
      return "ready:" + e;
    }
  }),
  U = /^utm_/,
  V = /^an_prop_/,
  L = /^an_trait_/;
function C(e) {
  var n = e.storage.setItem;
  return function (t) {
    return function (r) {
      return function (i) {
        if (i.type === q.bootstrap) {
          var a = i.params,
            o = i.user,
            u = i.persistedUser,
            c = i.initialUser,
            s = u.userId === o.userId;
          u.anonymousId !== o.anonymousId && n(A, o.anonymousId), s || n(_, o.userId), c.traits && n(x, v({}, s && u.traits ? u.traits : {}, c.traits));
          var l = Object.keys(i.params);
          if (l.length) {
            var f = a.an_uid,
              d = a.an_event,
              p = l.reduce(function (e, n) {
                if (n.match(U) || n.match(/^(d|g)clid/)) {
                  var t = n.replace(U, "");
                  e.campaign["campaign" === t ? "name" : t] = a[n];
                }
                return n.match(V) && (e.props[n.replace(V, "")] = a[n]), n.match(L) && (e.traits[n.replace(L, "")] = a[n]), e;
              }, {
                campaign: {},
                props: {},
                traits: {}
              });
            t.dispatch(v({
              type: q.params,
              raw: a
            }, p, f ? {
              userId: f
            } : {})), f && setTimeout(function () {
              return e.identify(f, p.traits);
            }, 0), d && setTimeout(function () {
              return e.track(d, p.props);
            }, 0), Object.keys(p.campaign).length && t.dispatch({
              type: q.campaign,
              campaign: p.campaign
            });
          }
        }
        return r(i);
      };
    };
  };
}
function R(e) {
  return function (n, t) {
    if (void 0 === n && (n = {}), void 0 === t && (t = {}), t.type === q.setItemEnd) {
      if (t.key === A) return v({}, n, {
        anonymousId: t.value
      });
      if (t.key === _) return v({}, n, {
        userId: t.value
      });
    }
    switch (t.type) {
      case q.identify:
        return Object.assign({}, n, {
          userId: t.userId,
          traits: v({}, n.traits, t.traits)
        });
      case q.reset:
        return [_, A, x].forEach(function (n) {
          e.removeItem(n);
        }), Object.assign({}, n, {
          userId: null,
          anonymousId: null,
          traits: {}
        });
      default:
        return n;
    }
  };
}
function $(e) {
  return {
    userId: e.getItem(_),
    anonymousId: e.getItem(A),
    traits: e.getItem(x)
  };
}
var D = function D(e) {
  return f + "TEMP" + f + e;
};
function B(n) {
  var t = n.storage,
    r = t.setItem,
    i = t.removeItem,
    a = t.getItem;
  return function (n) {
    return function (t) {
      return function (u) {
        var c = u.userId,
          s = u.traits,
          l = u.options;
        if (u.type === q.reset && ([_, x, A].forEach(function (e) {
          i(e);
        }), [j, T, "traits"].forEach(function (e) {
          o(D(e));
        })), u.type === q.identify) {
          a(A) || r(A, e());
          var f = a(_),
            d = a(x) || {};
          f && f !== c && n.dispatch({
            type: q.userIdChanged,
            old: {
              userId: f,
              traits: d
            },
            new: {
              userId: c,
              traits: s
            },
            options: l
          }), c && r(_, c), s && r(x, v({}, d, s));
        }
        return t(u);
      };
    };
  };
}
var X = {};
function J(e, n) {
  X[e] && d(X[e]) && (X[e](n), delete X[e]);
}
function W(e, n, t) {
  return new Promise(function (r, i) {
    return n() ? r(e) : t < 1 ? i(v({}, e, {
      queue: !0
    })) : new Promise(function (e) {
      return setTimeout(e, 10);
    }).then(function (a) {
      return W(e, n, t - 10).then(r, i);
    });
  });
}
function H(e, n, t) {
  var r = n(),
    i = e.getState(),
    a = i.plugins,
    o = i.queue,
    u = i.user;
  if (!i.context.offline && o && o.actions && o.actions.length) {
    var c = o.actions.reduce(function (e, n, t) {
      return a[n.plugin].loaded ? (e.process.push(n), e.processIndex.push(t)) : (e.requeue.push(n), e.requeueIndex.push(t)), e;
    }, {
      processIndex: [],
      process: [],
      requeue: [],
      requeueIndex: []
    });
    if (c.processIndex && c.processIndex.length) {
      c.processIndex.forEach(function (n) {
        var i = o.actions[n],
          c = i.plugin,
          s = i.payload.type,
          l = r[c][s];
        if (l && d(l)) {
          var f = function (e, n) {
            return void 0 === e && (e = {}), void 0 === n && (n = {}), [j, T].reduce(function (t, r) {
              return e.hasOwnProperty(r) && n[r] && n[r] !== e[r] && (t[r] = n[r]), t;
            }, e);
          }(i.payload, u);
          l({
            payload: f,
            config: a[c].config,
            instance: t
          });
          var p = s + ":" + c;
          e.dispatch(v({}, f, {
            type: p,
            _: {
              called: p,
              from: "queueDrain"
            }
          }));
        }
      });
      var s = o.actions.filter(function (e, n) {
        return !~c.processIndex.indexOf(n);
      });
      o.actions = s;
    }
  }
}
var F = function F(e) {
    var n = e.data,
      t = e.action,
      r = e.instance,
      i = e.state,
      a = e.allPlugins,
      o = e.allMatches,
      u = e.store,
      c = e.EVENTS;
    try {
      var s = i.plugins,
        f = i.context,
        p = t.type,
        m = p.match(G),
        g = n.exact.map(function (e) {
          return e.pluginName;
        });
      m && (g = o.during.map(function (e) {
        return e.pluginName;
      }));
      var h = function (e, n) {
          return function (t, r, i) {
            var a = r.config,
              o = r.name,
              u = o + "." + t.type;
            i && (u = i.event);
            var c = t.type.match(G) ? function (e, n, t, r, i) {
              return function (a, o) {
                var u = r ? r.name : e,
                  c = o && ie(o) ? o : t;
                if (r && (!(c = o && ie(o) ? o : [e]).includes(e) || 1 !== c.length)) throw new Error("Method " + n + " can only abort " + e + " plugin. " + JSON.stringify(c) + " input valid");
                return v({}, i, {
                  abort: {
                    reason: a,
                    plugins: c,
                    caller: n,
                    _: u
                  }
                });
              };
            }(o, u, n, i, t) : function (e, n) {
              return function () {
                throw new Error(e.type + " action not cancellable. Remove abort in " + n);
              };
            }(t, u);
            return {
              payload: ue(t),
              instance: e,
              config: a || {},
              abort: c
            };
          };
        }(r, g),
        y = n.exact.reduce(function (e, n) {
          var t = n.pluginName,
            r = n.methodName,
            i = !1;
          return r.match(/^initialize/) || r.match(/^reset/) || (i = !s[t].loaded), f.offline && r.match(/^(page|track|identify)/) && (i = !0), e["" + t] = i, e;
        }, {});
      return Promise.resolve(n.exact.reduce(function (e, i, o) {
        var u = i.pluginName;
        return Promise.resolve(e).then(function (e) {
          function i() {
            return Promise.resolve(e);
          }
          var o = function () {
            if (n.namespaced && n.namespaced[u]) return Promise.resolve(n.namespaced[u].reduce(function (e, n, t) {
              return Promise.resolve(e).then(function (e) {
                return n.method && d(n.method) ? (function (e, n) {
                  var t = oe(e);
                  if (t && t.name === n) {
                    var r = oe(t.method);
                    throw new Error([n + " plugin is calling method " + e, "Plugins cant call self", "Use " + t.method + " " + (r ? "or " + r.method : "") + " in " + n + " plugin insteadof " + e].join("\n"));
                  }
                }(n.methodName, n.pluginName), Promise.resolve(n.method({
                  payload: e,
                  instance: r,
                  abort: (t = e, i = u, o = n.pluginName, function (e, n) {
                    return v({}, t, {
                      abort: {
                        reason: e,
                        plugins: n || [i],
                        caller: p,
                        from: o || i
                      }
                    });
                  }),
                  config: Z(n.pluginName, s, a),
                  plugins: s
                })).then(function (n) {
                  var t = l(n) ? n : {};
                  return Promise.resolve(v({}, e, t));
                })) : e;
                var t, i, o;
              });
            }, Promise.resolve(t))).then(function (n) {
              e[u] = n;
            });
            e[u] = t;
          }();
          return o && o.then ? o.then(i) : i();
        });
      }, Promise.resolve({}))).then(function (e) {
        return Promise.resolve(n.exact.reduce(function (t, i, o) {
          try {
            var c = n.exact.length === o + 1,
              f = i.pluginName,
              d = a[f];
            return Promise.resolve(t).then(function (n) {
              var t = e[f] ? e[f] : {};
              if (m && (t = n), te(t, f)) return Y({
                data: t,
                method: p,
                instance: r,
                pluginName: f,
                store: u
              }), Promise.resolve(n);
              if (te(n, f)) return c && Y({
                data: n,
                method: p,
                instance: r,
                store: u
              }), Promise.resolve(n);
              if (y.hasOwnProperty(f) && !0 === y[f]) return u.dispatch({
                type: "queue",
                plugin: f,
                payload: t,
                _: {
                  called: "queue",
                  from: "queueMechanism"
                }
              }), Promise.resolve(n);
              var i = h(e[f], a[f]);
              return Promise.resolve(d[p]({
                abort: i.abort,
                payload: t,
                instance: r,
                config: Z(f, s, a),
                plugins: s
              })).then(function (i) {
                var a = l(i) ? i : {},
                  o = v({}, n, a),
                  c = e[f];
                if (te(c, f)) Y({
                  data: c,
                  method: p,
                  instance: r,
                  pluginName: f,
                  store: u
                });else {
                  var s = p + ":" + f;
                  (s.match(/:/g) || []).length < 2 && !p.match(K) && !p.match(Q) && r.dispatch(v({}, m ? o : t, {
                    type: s,
                    _: {
                      called: s,
                      from: "submethod"
                    }
                  }));
                }
                return Promise.resolve(o);
              });
            });
          } catch (e) {
            return Promise.reject(e);
          }
        }, Promise.resolve(t))).then(function (e) {
          if (!(p.match(G) || p.match(/^registerPlugin/) || p.match(Q) || p.match(K) || p.match(/^params/) || p.match(/^userIdChanged/))) {
            if (c.plugins.includes(p), e._ && e._.originalAction === p) return e;
            var t = v({}, e, {
              _: {
                originalAction: e.type,
                called: e.type,
                from: "engineEnd"
              }
            });
            re(e, n.exact.length) && !p.match(/End$/) && (t = v({}, t, {
              type: e.type + "Aborted"
            })), u.dispatch(t);
          }
          return e;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
  G = /Start$/,
  K = /^bootstrap/,
  Q = /^ready/;
function Y(e) {
  var n = e.pluginName,
    t = e.method + "Aborted" + (n ? ":" + n : "");
  e.store.dispatch(v({}, e.data, {
    type: t,
    _: {
      called: t,
      from: "abort"
    }
  }));
}
function Z(e, n, t) {
  var r = n[e] || t[e];
  return r && r.config ? r.config : {};
}
function ee(e, n) {
  return n.reduce(function (n, t) {
    return t[e] ? n.concat({
      methodName: e,
      pluginName: t.name,
      method: t[e]
    }) : n;
  }, []);
}
function ne(e, n) {
  var t = e.replace(G, ""),
    r = n ? ":" + n : "";
  return ["" + e + r, "" + t + r, t + "End" + r];
}
function te(e, n) {
  var t = e.abort;
  return !!t && (!0 === t || ae(t, n) || t && ae(t.plugins, n));
}
function re(e, n) {
  var t = e.abort;
  if (!t) return !1;
  if (!0 === t || m(t)) return !0;
  var r = t.plugins;
  return ie(t) && t.length === n || ie(r) && r.length === n;
}
function ie(e) {
  return Array.isArray(e);
}
function ae(e, n) {
  return !(!e || !ie(e)) && e.includes(n);
}
function oe(e) {
  var n = e.match(/(.*):(.*)/);
  return !!n && {
    method: n[1],
    name: n[2]
  };
}
function ue(e) {
  return Object.keys(e).reduce(function (n, t) {
    return "type" === t || (n[t] = l(e[t]) ? Object.assign({}, e[t]) : e[t]), n;
  }, {});
}
function ce(e, n, t) {
  var r = {};
  return function (i) {
    return function (a) {
      return function (o) {
        try {
          var u,
            c = function c(e) {
              return u ? e : a(f);
            },
            s = o.type,
            l = o.plugins,
            f = o;
          if (o.abort) return Promise.resolve(a(o));
          if (s === q.enablePlugin && i.dispatch({
            type: q.initializeStart,
            plugins: l,
            disabled: [],
            fromEnable: !0,
            meta: o.meta
          }), s === q.disablePlugin && setTimeout(function () {
            return J(o.meta.rid, {
              payload: o
            });
          }, 0), s === q.initializeEnd) {
            var m = n(),
              g = Object.keys(m),
              h = g.filter(function (e) {
                return l.includes(e);
              }).map(function (e) {
                return m[e];
              }),
              y = [],
              b = [],
              I = o.disabled,
              w = h.map(function (e) {
                var n = e.name;
                return W(e, e.loaded, 1e4).then(function (t) {
                  return r[n] || (i.dispatch({
                    type: q.pluginReadyType(n),
                    name: n,
                    events: Object.keys(e).filter(function (e) {
                      return !M.includes(e);
                    })
                  }), r[n] = !0), y = y.concat(n), e;
                }).catch(function (e) {
                  if (e instanceof Error) throw new Error(e);
                  return b = b.concat(e.name), e;
                });
              });
            Promise.all(w).then(function (e) {
              var n = {
                plugins: y,
                failed: b,
                disabled: I
              };
              setTimeout(function () {
                g.length === w.length + I.length && i.dispatch(v({}, {
                  type: q.ready
                }, n));
              }, 0);
            });
          }
          var E = function () {
            if (s !== q.bootstrap) return /^ready:([^:]*)$/.test(s) && setTimeout(function () {
              return H(i, n, e);
            }, 0), Promise.resolve(function (e, n, t, r, i) {
              try {
                var a = d(n) ? n() : n,
                  o = e.type,
                  u = o.replace(G, "");
                if (e._ && e._.called) return Promise.resolve(e);
                var c = t.getState(),
                  s = (m = a, void 0 === (g = c.plugins) && (g = {}), void 0 === (h = e.options) && (h = {}), Object.keys(m).filter(function (e) {
                    var n = h.plugins || {};
                    return p(n[e]) ? n[e] : !1 !== n.all && (!g[e] || !1 !== g[e].enabled);
                  }).map(function (e) {
                    return m[e];
                  }));
                o === q.initializeStart && e.fromEnable && (s = Object.keys(c.plugins).filter(function (n) {
                  var t = c.plugins[n];
                  return e.plugins.includes(n) && !t.initialized;
                }).map(function (e) {
                  return a[e];
                }));
                var l = s.map(function (e) {
                    return e.name;
                  }),
                  f = function (e, n, t) {
                    var r = ne(e).map(function (e) {
                      return ee(e, n);
                    });
                    return n.reduce(function (t, r) {
                      var i = r.name,
                        a = ne(e, i).map(function (e) {
                          return ee(e, n);
                        }),
                        o = a[0],
                        u = a[1],
                        c = a[2];
                      return o.length && (t.beforeNS[i] = o), u.length && (t.duringNS[i] = u), c.length && (t.afterNS[i] = c), t;
                    }, {
                      before: r[0],
                      beforeNS: {},
                      during: r[1],
                      duringNS: {},
                      after: r[2],
                      afterNS: {}
                    });
                  }(o, s);
                return Promise.resolve(F({
                  action: e,
                  data: {
                    exact: f.before,
                    namespaced: f.beforeNS
                  },
                  state: c,
                  allPlugins: a,
                  allMatches: f,
                  instance: t,
                  store: r,
                  EVENTS: i
                })).then(function (e) {
                  function n() {
                    var n = function () {
                      if (o.match(G)) return Promise.resolve(F({
                        action: v({}, s, {
                          type: u + "End"
                        }),
                        data: {
                          exact: f.after,
                          namespaced: f.afterNS
                        },
                        state: c,
                        allPlugins: a,
                        allMatches: f,
                        instance: t,
                        store: r,
                        EVENTS: i
                      })).then(function (e) {
                        e.meta && e.meta.hasCallback && J(e.meta.rid, {
                          payload: e
                        });
                      });
                    }();
                    return n && n.then ? n.then(function () {
                      return e;
                    }) : e;
                  }
                  if (re(e, l.length)) return e;
                  var s,
                    d = function () {
                      if (o !== u) return Promise.resolve(F({
                        action: v({}, e, {
                          type: u
                        }),
                        data: {
                          exact: f.during,
                          namespaced: f.duringNS
                        },
                        state: c,
                        allPlugins: a,
                        allMatches: f,
                        instance: t,
                        store: r,
                        EVENTS: i
                      })).then(function (e) {
                        s = e;
                      });
                      s = e;
                    }();
                  return d && d.then ? d.then(n) : n();
                });
              } catch (e) {
                return Promise.reject(e);
              }
              var m, g, h;
            }(o, n, e, i, t)).then(function (e) {
              var n = a(e);
              return u = 1, n;
            });
          }();
          return Promise.resolve(E && E.then ? E.then(c) : c(E));
        } catch (e) {
          return Promise.reject(e);
        }
      };
    };
  };
}
function se(e) {
  return function (n) {
    return function (n) {
      return function (t) {
        var r = t.type,
          i = t.key,
          a = t.value,
          o = t.options;
        if (r === q.setItem || r === q.removeItem) {
          if (t.abort) return n(t);
          r === q.setItem ? e.setItem(i, a, o) : e.removeItem(i, o);
        }
        return n(t);
      };
    };
  };
}
var le = function le() {
  var e = this;
  this.before = [], this.after = [], this.addMiddleware = function (n, t) {
    e[t] = e[t].concat(n);
  }, this.removeMiddleware = function (n, t) {
    var r = e[t].findIndex(function (e) {
      return e === n;
    });
    -1 !== r && (e[t] = [].concat(e[t].slice(0, r), e[t].slice(r + 1)));
  }, this.dynamicMiddlewares = function (n) {
    return function (t) {
      return function (r) {
        return function (i) {
          var a = {
              getState: t.getState,
              dispatch: function dispatch(e) {
                return t.dispatch(e);
              }
            },
            o = e[n].map(function (e) {
              return e(a);
            });
          return N.apply(void 0, o)(r)(i);
        };
      };
    };
  };
};
function fe(e) {
  return function (n, t) {
    void 0 === n && (n = {});
    var r = {};
    if ("initialize:aborted" === t.type) return n;
    if (/^registerPlugin:([^:]*)$/.test(t.type)) {
      var i = de(t.type, "registerPlugin"),
        a = e()[i];
      if (!a || !i) return n;
      var o = t.enabled;
      return r[i] = {
        enabled: o,
        initialized: !!o && Boolean(!a.initialize),
        loaded: !!o && Boolean(a.loaded()),
        config: a.config || {}
      }, v({}, n, r);
    }
    if (/^initialize:([^:]*)$/.test(t.type)) {
      var u = de(t.type, q.initialize),
        c = e()[u];
      return c && u ? (r[u] = v({}, n[u], {
        initialized: !0,
        loaded: Boolean(c.loaded())
      }), v({}, n, r)) : n;
    }
    if (/^ready:([^:]*)$/.test(t.type)) return r[t.name] = v({}, n[t.name], {
      loaded: !0
    }), v({}, n, r);
    switch (t.type) {
      case q.disablePlugin:
        return v({}, n, pe(t.plugins, !1, n));
      case q.enablePlugin:
        return v({}, n, pe(t.plugins, !0, n));
      default:
        return n;
    }
  };
}
function de(e, n) {
  return e.substring(n.length + 1, e.length);
}
function pe(e, n, t) {
  return e.reduce(function (e, r) {
    return e[r] = v({}, t[r], {
      enabled: n
    }), e;
  }, t);
}
function me(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch (e) {}
  return e;
}
var ge = {
  last: {},
  history: []
};
function he(e, n) {
  void 0 === e && (e = ge);
  var t = n.options,
    r = n.meta;
  if (n.type === q.track) {
    var i = me(v({
      event: n.event,
      properties: n.properties
    }, Object.keys(t).length && {
      options: t
    }, {
      meta: r
    }));
    return v({}, e, {
      last: i,
      history: e.history.concat(i)
    });
  }
  return e;
}
var ve = {
  actions: []
};
function ye(e, n) {
  void 0 === e && (e = ve);
  var t = n.payload;
  switch (n.type) {
    case "queue":
      var r;
      return r = t && t.type && t.type === q.identify ? [n].concat(e.actions) : e.actions.concat(n), v({}, e, {
        actions: r
      });
    case "dequeue":
      return [];
    default:
      return e;
  }
}
var be = /#.*$/;
function Ie(e) {
  var n = /(http[s]?:\/\/)?([^\/\s]+\/)(.*)/g.exec(e);
  return "/" + (n && n[3] ? n[3].split("?")[0].replace(be, "") : "");
}
var we,
  Ee,
  Pe,
  Se,
  Ne = function Ne(e) {
    if (void 0 === e && (e = {}), !g) return e;
    var n = document,
      t = n.title,
      r = n.referrer,
      i = window,
      a = i.location,
      o = i.innerWidth,
      u = i.innerHeight,
      c = a.hash,
      s = a.search,
      l = function (e) {
        var n = function () {
          if (g) for (var e, n = document.getElementsByTagName("link"), t = 0; e = n[t]; t++) if ("canonical" === e.getAttribute("rel")) return e.getAttribute("href");
        }();
        return n ? n.match(/\?/) ? n : n + e : window.location.href.replace(be, "");
      }(s),
      f = {
        title: t,
        url: l,
        path: Ie(l),
        hash: c,
        search: s,
        width: o,
        height: u
      };
    return r && "" !== r && (f.referrer = r), v({}, f, e);
  },
  Oe = {
    last: {},
    history: []
  };
function Ae(e, n) {
  void 0 === e && (e = Oe);
  var t = n.options;
  if (n.type === q.page) {
    var r = me(v({
      properties: n.properties,
      meta: n.meta
    }, Object.keys(t).length && {
      options: t
    }));
    return v({}, e, {
      last: r,
      history: e.history.concat(r)
    });
  }
  return e;
}
we = function () {
  if (!g) return !1;
  var e = navigator.appVersion;
  return ~e.indexOf("Win") ? "Windows" : ~e.indexOf("Mac") ? "MacOS" : ~e.indexOf("X11") ? "UNIX" : ~e.indexOf("Linux") ? "Linux" : "Unknown OS";
}(), Ee = g ? document.referrer : null, Pe = n(), Se = t();
var _e = {
  initialized: !1,
  sessionId: e(),
  app: null,
  version: null,
  debug: !1,
  offline: !!g && !navigator.onLine,
  os: {
    name: we
  },
  userAgent: g ? navigator.userAgent : "node",
  library: {
    name: "analytics",
    version: "0.11.0"
  },
  timezone: Se,
  locale: Pe,
  campaign: {},
  referrer: Ee
};
function xe(e, n) {
  void 0 === e && (e = _e);
  var t = e.initialized,
    r = n.campaign;
  switch (n.type) {
    case q.campaign:
      return v({}, e, {
        campaign: r
      });
    case q.offline:
      return v({}, e, {
        offline: !0
      });
    case q.online:
      return v({}, e, {
        offline: !1
      });
    default:
      return t ? e : v({}, _e, e, {
        initialized: !0
      });
  }
}
var ke = ["plugins", "reducers", "storage"];
function je(e, n, t) {
  if (g) {
    var r = window[(t ? "add" : "remove") + "EventListener"];
    e.split(" ").forEach(function (e) {
      r(e, n);
    });
  }
}
function Te(e) {
  var n = je.bind(null, "online offline", function (n) {
    return Promise.resolve(!navigator.onLine).then(e);
  });
  return n(!0), function (e) {
    return n(!1);
  };
}
function ze() {
  return u("analytics", []), function (e) {
    return function (n, t, r) {
      var i = e(n, t, r),
        a = i.dispatch;
      return Object.assign(i, {
        dispatch: function dispatch(e) {
          return c[s].analytics.push(e.action || e), a(e);
        }
      });
    };
  };
}
function Me(e) {
  return function () {
    return N(N.apply(null, arguments), ze());
  };
}
function qe(e) {
  return e ? h(e) ? e : [e] : [];
}
function Ue(n, t, r) {
  void 0 === n && (n = {});
  var i,
    a,
    o = e();
  return t && (X[o] = (i = t, a = function (e) {
    for (var n, t = e || Array.prototype.slice.call(arguments), r = 0; r < t.length; r++) if (d(t[r])) {
      n = t[r];
      break;
    }
    return n;
  }(r), function (e) {
    a && a(e), i(e);
  })), v({}, n, {
    rid: o,
    ts: new Date().getTime()
  }, t ? {
    hasCallback: !0
  } : {});
}
function Ve(n) {
  void 0 === n && (n = {});
  var t = n.reducers || {},
    c = n.initialUser || {},
    s = (n.plugins || []).reduce(function (e, n) {
      if (d(n)) return e.middlewares = e.middlewares.concat(n), e;
      if (n.NAMESPACE && (n.name = n.NAMESPACE), !n.name) throw new Error("https://lytics.dev/errors/1");
      var t = n.EVENTS ? Object.keys(n.EVENTS).map(function (e) {
        return n.EVENTS[e];
      }) : [];
      e.pluginEnabled[n.name] = !(!1 === n.enabled || n.config && !1 === n.config.enabled), delete n.enabled, n.methods && (e.methods[n.name] = Object.keys(n.methods).reduce(function (e, t) {
        var r;
        return e[t] = (r = n.methods[t], function () {
          for (var e = Array.prototype.slice.call(arguments), n = new Array(r.length), t = 0; t < e.length; t++) n[t] = e[t];
          return n[n.length] = K, r.apply({
            instance: K
          }, n);
        }), e;
      }, {}), delete n.methods);
      var r = Object.keys(n).concat(t),
        i = new Set(e.events.concat(r));
      if (e.events = Array.from(i), e.pluginsArray = e.pluginsArray.concat(n), e.plugins[n.name]) throw new Error(n.name + "AlreadyLoaded");
      return e.plugins[n.name] = n, e.plugins[n.name].loaded || (e.plugins[n.name].loaded = function () {
        return !0;
      }), e;
    }, {
      plugins: {},
      pluginEnabled: {},
      methods: {},
      pluginsArray: [],
      middlewares: [],
      events: []
    }),
    f = n.storage ? n.storage : {
      getItem: a,
      setItem: u,
      removeItem: o
    },
    p = function (e) {
      return function (n, t, r) {
        return t.getState("user")[n] || (r && l(r) && r[n] ? r[n] : $(e)[n] || a(D(n)) || null);
      };
    }(f),
    h = s.plugins,
    w = s.events.filter(function (e) {
      return !M.includes(e);
    }).sort(),
    E = new Set(w.concat(z).filter(function (e) {
      return !M.includes(e);
    })),
    _ = Array.from(E).sort(),
    x = function x() {
      return h;
    },
    k = new le(),
    U = k.addMiddleware,
    V = k.removeMiddleware,
    L = k.dynamicMiddlewares,
    X = function X() {
      throw new Error("Abort disabled inListener");
    },
    J = r(),
    W = $(f),
    F = v({}, W, c, J.an_uid ? {
      userId: J.an_uid
    } : {}, J.an_aid ? {
      anonymousId: J.an_aid
    } : {});
  F.anonymousId || (F.anonymousId = e());
  var G = v({
      enable: function enable(e, n) {
        return new Promise(function (t) {
          oe.dispatch({
            type: q.enablePlugin,
            plugins: qe(e),
            _: {
              originalAction: q.enablePlugin
            }
          }, t, [n]);
        });
      },
      disable: function disable(e, n) {
        return new Promise(function (t) {
          oe.dispatch({
            type: q.disablePlugin,
            plugins: qe(e),
            _: {
              originalAction: q.disablePlugin
            }
          }, t, [n]);
        });
      }
    }, s.methods),
    K = {
      identify: function identify(e, n, t, r) {
        try {
          var i = m(e) ? e : null,
            a = l(e) ? e : n,
            o = t || {},
            c = K.user();
          u(D(j), i);
          var s = i || a.userId || p(j, K, a);
          return Promise.resolve(new Promise(function (e) {
            oe.dispatch(v({
              type: q.identifyStart,
              userId: s,
              traits: a || {},
              options: o,
              anonymousId: c.anonymousId
            }, c.id && c.id !== i && {
              previousId: c.id
            }), e, [n, t, r]);
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      },
      track: function track(e, n, t, r) {
        try {
          var i = l(e) ? e.event : e;
          if (!i || !m(i)) throw new Error("EventMissing");
          var a = l(e) ? e : n || {},
            o = l(t) ? t : {};
          return Promise.resolve(new Promise(function (e) {
            oe.dispatch({
              type: q.trackStart,
              event: i,
              properties: a,
              options: o,
              userId: p(j, K, n),
              anonymousId: p(T, K, n)
            }, e, [n, t, r]);
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      },
      page: function page(e, n, t) {
        try {
          var r = l(e) ? e : {},
            i = l(n) ? n : {};
          return Promise.resolve(new Promise(function (a) {
            oe.dispatch({
              type: q.pageStart,
              properties: Ne(r),
              options: i,
              userId: p(j, K, r),
              anonymousId: p(T, K, r)
            }, a, [e, n, t]);
          }));
        } catch (e) {
          return Promise.reject(e);
        }
      },
      user: function user(e) {
        if (e === j || "id" === e) return p(j, K);
        if (e === T || "anonId" === e) return p(T, K);
        var n = K.getState("user");
        return e ? i(n, e) : n;
      },
      reset: function reset(e) {
        return new Promise(function (n) {
          oe.dispatch({
            type: q.resetStart
          }, n, e);
        });
      },
      ready: function ready(e) {
        return K.on(q.ready, e);
      },
      on: function on(e, n) {
        if (!e || !d(n)) return !1;
        if (e === q.bootstrap) throw new Error(".on disabled for " + e);
        var t = /Start$|Start:/;
        if ("*" === e) {
          var r = function r(e) {
              return function (e) {
                return function (r) {
                  return r.type.match(t) && n({
                    payload: r,
                    instance: K,
                    plugins: h
                  }), e(r);
                };
              };
            },
            i = function i(e) {
              return function (e) {
                return function (r) {
                  return r.type.match(t) || n({
                    payload: r,
                    instance: K,
                    plugins: h
                  }), e(r);
                };
              };
            };
          return U(r, Le), U(i, Ce), function () {
            V(r, Le), V(i, Ce);
          };
        }
        var a = e.match(t) ? Le : Ce,
          o = function o(t) {
            return function (t) {
              return function (r) {
                return r.type === e && n({
                  payload: r,
                  instance: K,
                  plugins: h,
                  abort: X
                }), t(r);
              };
            };
          };
        return U(o, a), function () {
          return V(o, a);
        };
      },
      once: function once(e, n) {
        if (!e || !d(n)) return !1;
        if (e === q.bootstrap) throw new Error(".once disabled for " + e);
        var t = K.on(e, function (e) {
          n({
            payload: e.payload,
            instance: K,
            plugins: h,
            abort: X
          }), t();
        });
        return t;
      },
      getState: function getState(e) {
        var n = oe.getState();
        return e ? i(n, e) : Object.assign({}, n);
      },
      dispatch: function dispatch(e) {
        var n = m(e) ? {
          type: e
        } : e;
        if (z.includes(n.type)) throw new Error("reserved action " + n.type);
        var t = v({}, n, {
          _: v({
            originalAction: n.type
          }, e._ || {})
        });
        oe.dispatch(t);
      },
      enablePlugin: G.enable,
      disablePlugin: G.disable,
      plugins: G,
      storage: {
        getItem: f.getItem,
        setItem: function setItem(e, n, t) {
          oe.dispatch({
            type: q.setItemStart,
            key: e,
            value: n,
            options: t
          });
        },
        removeItem: function removeItem(e, n) {
          oe.dispatch({
            type: q.removeItemStart,
            key: e,
            options: n
          });
        }
      },
      setAnonymousId: function setAnonymousId(e, n) {
        K.storage.setItem(A, e, n);
      },
      events: {
        core: z,
        plugins: w
      }
    },
    Q = s.middlewares.concat([function (e) {
      return function (e) {
        return function (n) {
          return n.meta || (n.meta = Ue()), e(n);
        };
      };
    }, L(Le), ce(K, x, {
      all: _,
      plugins: w
    }), se(f), C(K), B(K), L(Ce)]),
    Y = {
      context: xe,
      user: R(f),
      page: Ae,
      track: he,
      plugins: fe(x),
      queue: ye
    },
    Z = N,
    ee = N;
  if (g && n.debug) {
    var ne = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    ne && (Z = ne({
      trace: !0,
      traceLimit: 25
    })), ee = function ee() {
      return 0 === arguments.length ? ze() : l(typeof arguments[0]) ? Me() : Me().apply(null, arguments);
    };
  }
  var te,
    re = function (e) {
      return Object.keys(e).reduce(function (n, t) {
        return ke.includes(t) || (n[t] = e[t]), n;
      }, {});
    }(n),
    ie = s.pluginsArray.reduce(function (e, n) {
      var t = n.name,
        r = n.config,
        i = n.loaded,
        a = s.pluginEnabled[t];
      return e[t] = {
        enabled: a,
        initialized: !!a && Boolean(!n.initialize),
        loaded: Boolean(i()),
        config: r || {}
      }, e;
    }, {}),
    ae = {
      context: re,
      user: F,
      plugins: ie
    },
    oe = P(function (e) {
      for (var n = Object.keys(e), t = {}, r = 0; r < n.length; r++) {
        var i = n[r];
        typeof e[i] === y && (t[i] = e[i]);
      }
      var a,
        o = Object.keys(t);
      try {
        !function (e) {
          Object.keys(e).forEach(function (n) {
            var t = e[n];
            if (typeof t(void 0, {
              type: "@@redux/INIT"
            }) === b || typeof t(void 0, {
              type: I
            }) === b) throw new Error("reducer " + n + " " + b);
          });
        }(t);
      } catch (e) {
        a = e;
      }
      return function (e, n) {
        if (void 0 === e && (e = {}), a) throw a;
        for (var r = !1, i = {}, u = 0; u < o.length; u++) {
          var c = o[u],
            s = e[c],
            l = (0, t[c])(s, n);
          if (typeof l === b) {
            var f = S(c, n);
            throw new Error(f);
          }
          i[c] = l, r = r || l !== s;
        }
        return r ? i : e;
      };
    }(v({}, Y, t)), ae, ee(Z(O.apply(void 0, Q))));
  oe.dispatch = (te = oe.dispatch, function (e, n, t) {
    var r = v({}, e, {
      meta: Ue(e.meta, n, qe(t))
    });
    return te.apply(null, [r]);
  });
  var ue = Object.keys(h);
  oe.dispatch({
    type: q.bootstrap,
    plugins: ue,
    config: re,
    params: J,
    user: F,
    initialUser: c,
    persistedUser: W
  });
  var de = ue.filter(function (e) {
      return s.pluginEnabled[e];
    }),
    pe = ue.filter(function (e) {
      return !s.pluginEnabled[e];
    });
  return oe.dispatch({
    type: q.registerPlugins,
    plugins: ue,
    enabled: s.pluginEnabled
  }), s.pluginsArray.map(function (e, n) {
    var t = e.bootstrap,
      r = e.config,
      i = e.name;
    t && d(t) && t({
      instance: K,
      config: r,
      payload: e
    }), oe.dispatch({
      type: q.registerPluginType(i),
      name: i,
      enabled: s.pluginEnabled[i],
      plugin: e
    }), s.pluginsArray.length === n + 1 && oe.dispatch({
      type: q.initializeStart,
      plugins: de,
      disabled: pe
    });
  }), Te(function (e) {
    oe.dispatch({
      type: e ? q.offline : q.online
    });
  }), function (e, n, t) {
    setInterval(function () {
      return H(e, n, t);
    }, 3e3);
  }(oe, x, K), K;
}
var Le = "before",
  Ce = "after";
export { Ve as Analytics, k as CONSTANTS, q as EVENTS, Ve as default, Ve as init };